import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { Medida } from "../shared/medida.model";
import { MedidaService } from "../shared/medida.service";
import {medidasModuleName, medidasStorage} from "../shared/data.service";
import {MedidaNavigationService} from "../shared/medida-navigation.service";
import {MedidaApiService} from "../shared/medida-api.service";
import {UtilService} from "../../../shared/services/util.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {editRoute, newRouteFemale} from "../../../shared/services/data.service";

declare var swal: any;

@Component({
  template: require('./medida-form.component.html'),
})

export class MedidaFormComponent implements OnInit {
  medidaModule: string = medidasModuleName;
  formObject: any = new Medida();
  actionTitle: string;
  submitted: boolean = false;
  btnSaveDisabled: boolean = false;

  form: FormGroup;
  medida = new FormControl('', Validators.required);
  ativo = new FormControl();

  private returnToOtherForm: boolean = false;
  private otherForm: string = "";
  private responseMedida: any;

  constructor(
    private _route: ActivatedRoute,
    private _medidaNavigationService: MedidaNavigationService,
    private _medidaApiService: MedidaApiService,
    private _medidaService: MedidaService,
    private _utilService: UtilService,
    private _autocompleteService: AutoCompleteService,
    private _fb: FormBuilder
  ){
    this.form = _fb.group({
      ativo: this.ativo,
      medida: this.medida
    });
  }

  ngOnInit() {
    this.isNewAutoComplete();
  }

  clickGoToList() {
    this.goToList();
  }

  clickCancel() {
    this.toLeaveHere();
  }

  onSubmit(evt: any) {
    this.submitted = true;
    if(evt.valid) {
      this.btnSaveDisabled = true;
      var object:Medida = this._utilService.cloneObject(this.formObject);

      if (this.formObject.id) {
        this.onEditMedida(object);
      } else {
        this.onAddMedida(object);
      }
    }
  }

  private onAddMedida(object: Medida) {
    this._medidaApiService.onPost(object, this.onDone);
  }

  private onEditMedida(object: Medida) {
    this._medidaApiService.onPut(object, this.onDone);
  }

  private onDone = (function (Response: any) {
    if (!Response.error)  {
      this.responseMedida = Response;
      if (this.formObject.id) {
        this._utilService.swalMessageEditSuccess();
      } else {
        this._utilService.swalMessageAddSuccess();
      }

      this.toLeaveHere();
    } else {
      this.btnSaveDisabled = false;
      this._utilService.swalMessageWarningCustom(Response.error);
    }
  }.bind(this));

  private getObject(id: number) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.formObject = Response;
        this.setModelToForm();

      } else {
        this._utilService.swalMessageWarningCustom('Nenhuma unidade de medida encontrada com este id.');
        this.toLeaveHere();
      }
    }.bind(this));

    this._medidaApiService.onGetById(id, onDone);
  }

  private testSession() {
    var id: number;
    var session: any = this._medidaService.getSessionStorage();
    this._medidaService.clearSessionStorage();

    if (session) {
      this.formObject = session;
      id = session.id;
      this.setModelToForm();
    } else {
      id = +this._route.snapshot.params['id'];
      if (id) {
        this.setEditNormal(id);
      } else {
        this.setNewNormal();
      }
    }

    this.setActionTitle(id);
  }

  private setActionTitle(id: number) {
    if (id) {
      this.actionTitle = editRoute;
    } else {
      this.actionTitle = newRouteFemale;
    }
  }

  private setEditNormal(id: number) {
    this.getObject(id);
  }

  private setNewNormal() {
    //se tiver alguma configuração inicial de um cadastro novo
  }

  private setEditSession() {
    //qndo retornou para continuar a edição
  }

  private setNewSession() {
    //qndo retornou para continuar o cadastro
  }

  private isNewAutoComplete() {
    var newAutoComplete: any = this._autocompleteService.getSessionStorage(medidasStorage);
    if (newAutoComplete) {
      this.returnToOtherForm = true;
      this.otherForm = newAutoComplete.form;
      this.formObject.medida = newAutoComplete.medida;

      this.setActionTitle(this.formObject.id);
    } else {
      //retornando de um cadastro
      this.testSession();
    }
  }

  private setModelToForm() {

  }

  private goToList() {
    this._medidaNavigationService.goToList();
  }

  private toLeaveHere() {
    if (this.returnToOtherForm) {
      this._medidaService.returnToOtherForm(this.otherForm, this.responseMedida);
    } else {
      this.goToList();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/medida-form/medida-form.component.ts
 **/